import { render, staticRenderFns } from "./DokmanComponentPruefungSchritte.vue?vue&type=template&id=c29acdd2&scoped=true"
import script from "./DokmanComponentPruefungSchritte.vue?vue&type=script&lang=js"
export * from "./DokmanComponentPruefungSchritte.vue?vue&type=script&lang=js"
import style0 from "./DokmanComponentPruefungSchritte.vue?vue&type=style&index=0&id=c29acdd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29acdd2",
  null
  
)

export default component.exports